import * as React from 'react';

function CollapsIcon({ fill = '#6C7281', ...rest }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="35" viewBox="0 0 21 50" fill="none">
      <path d="M0 8C0 3.58172 3.58172 0 8 0H21V49.875H8C3.58172 49.875 0 46.2933 0 41.875V8Z" fill="#D6242C" />
      <path
        d="M6.1709 26.3617C5.69152 25.962 5.69152 25.2255 6.1709 24.8258L12.4689 19.5735C13.1202 19.0304 14.1094 19.4935 14.1094 20.3415L14.1094 30.846C14.1094 31.694 13.1202 32.1571 12.4689 31.614L6.1709 26.3617Z"
        fill="white"
      />
    </svg>
  );
}

export default CollapsIcon;
